import React from "react";

const ScanInputSection = ({
    inputRef,
    scanMode,
    setScanMode,
    inventoryMode,
    setInventoryMode,
    onSubmit,
}) => {
    const isCase = scanMode === "case";
    const eachLabel = inventoryMode ? "Carton UPC" : "Each UPC";
    const eachIcon = inventoryMode ? "fa-boxes-stacked" : "fa-tag";

    return (
        <div className="mb-8">
            <div className="flex justify-center mb-4">
                <label className="inline-flex items-center gap-3 cursor-pointer select-none">
                    <span className={`text-[14px] font-semibold ${inventoryMode ? "text-blue-600" : "text-gray-400"}`}>
                        Inventory
                    </span>
                    <button
                        type="button"
                        role="switch"
                        aria-checked={inventoryMode}
                        onClick={() => setInventoryMode(!inventoryMode)}
                        className={`relative w-12 h-7 rounded-full transition-colors ${
                            inventoryMode ? "bg-blue-600" : "bg-gray-300"
                        }`}
                    >
                        <span
                            className={`absolute top-0.5 left-0.5 w-6 h-6 rounded-full bg-white shadow transition-transform ${
                                inventoryMode ? "translate-x-5" : "translate-x-0"
                            }`}
                        />
                    </button>
                </label>
            </div>

            <div className="flex justify-center mb-5">
                <div className="inline-flex rounded-2xl overflow-hidden border-2 border-blue-600 shadow-md">
                    <button
                        type="button"
                        onClick={() => setScanMode("case")}
                        className={`flex items-center gap-2 px-8 py-3 text-[15px] font-bold transition-colors ${
                            isCase
                                ? "bg-blue-600 text-white"
                                : "bg-white text-blue-600 hover:bg-blue-50"
                        }`}
                    >
                        <i className="fa-solid fa-box" />
                        Case UPC
                    </button>
                    <div className="w-[2px] bg-blue-600" />
                    <button
                        type="button"
                        onClick={() => setScanMode("each")}
                        className={`flex items-center gap-2 px-8 py-3 text-[15px] font-bold transition-colors ${
                            !isCase
                                ? "bg-blue-600 text-white"
                                : "bg-white text-blue-600 hover:bg-blue-50"
                        }`}
                    >
                        <i className={`fa-solid ${eachIcon}`} />
                        {eachLabel}
                    </button>
                </div>
            </div>

            <p className="text-center text-[13px] text-gray-400 mb-4">
                {inventoryMode
                    ? isCase
                        ? "Case UPC — quantity is pulled from the wholesale price book"
                        : "Carton UPC — quantity is pulled from the wholesale price book"
                    : isCase
                      ? "Case UPC — quantity is pulled from the master price book mapping"
                      : "Each UPC — every scan counts as 1 unit"}
            </p>

            <div className="relative">
                <i className="fa-solid fa-barcode absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-[18px]" />
                <input
                    ref={inputRef}
                    type="text"
                    autoComplete="off"
                    defaultValue=""
                    placeholder={
                        isCase
                            ? "Scan or type case barcode and press Enter..."
                            : inventoryMode
                              ? "Scan or type carton barcode and press Enter..."
                              : "Scan or type item barcode and press Enter..."
                    }
                    className="w-full border-2 border-gray-200 focus:border-blue-500 rounded-2xl pl-12 pr-4 py-4 text-[16px] outline-none transition-colors shadow-sm cursor-text"
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            const raw = e.currentTarget.value.trim();
                            e.currentTarget.value = "";
                            if (raw) onSubmit(raw);
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default ScanInputSection;
